import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import { useMount } from "~/services/utils/hooks";
import { zendeskActions, zendeskSelectors } from "~/services/zendesk";
var Zendesk = function(param) {
    var autoOpen = param.autoOpen, children = param.children, hasZendeskScriptLoaded = param.hasZendeskScriptLoaded, hasZendeskScriptLoadedAndDelayed = param.hasZendeskScriptLoadedAndDelayed, loadZendeskScript = param.loadZendeskScript, unmountCheck = param.unmountCheck, suppressHelpCenter = param.suppressHelpCenter;
    useMount(function() {
        if (!hasZendeskScriptLoaded) {
            loadZendeskScript();
        }
        return function() {
            if (unmountCheck() && window.zE) {
                window.zE("webWidget", "hide");
            }
        };
    });
    useEffect(function() {
        if (hasZendeskScriptLoaded && window.zE) {
            window.zE("webWidget", "updatePath");
            window.zE("webWidget", "show");
            // Define suppressions on mount. Don't undo on unmount since it may change the text
            // on the button while it is fading out. Better to only change it on mount for each
            // page.
            window.zE("webWidget", "updateSettings", {
                webWidget: {
                    helpCenter: {
                        suppress: !!suppressHelpCenter
                    }
                }
            });
            if (autoOpen) {
                window.zE("webWidget", "open");
            }
        }
    }, [
        autoOpen,
        hasZendeskScriptLoaded,
        suppressHelpCenter
    ]);
    if (typeof children === "function") {
        return children({
            loading: !hasZendeskScriptLoaded,
            hasLoadedAndDelayed: hasZendeskScriptLoadedAndDelayed
        });
    }
    return null;
};
Zendesk.propTypes = {
    autoOpen: PropTypes.bool,
    hasZendeskScriptLoaded: PropTypes.bool,
    hasZendeskScriptLoadedAndDelayed: PropTypes.bool,
    loadZendeskScript: PropTypes.func.isRequired,
    unmountCheck: PropTypes.func,
    suppressHelpCenter: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.node
    ])
};
Zendesk.defaultProps = {
    unmountCheck: function() {
        return true;
    }
};
var mapStateToProps = function(state) {
    return {
        hasZendeskScriptLoaded: zendeskSelectors.hasZendeskScriptLoaded(state),
        hasZendeskScriptLoadedAndDelayed: zendeskSelectors.hasZendeskScriptLoadedAndDelayed(state)
    };
};
var mapDispatchToProps = {
    loadZendeskScript: zendeskActions.loadZendeskScript
};
export default connect(mapStateToProps, mapDispatchToProps)(Zendesk);
